import React, { useState } from "react";
import AccountLayout from "./AccountLayout";
import BettingSettled from "./BettingSettled";
import BettingHistoryFilter from "./BettingHistoryFilter";
import { isEmpty, set } from "lodash";
import { t } from "i18next";
import BettingUnSettled from "./BettingUnSettled";
import moment from "moment";

const BettingHistory = () => {
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [show, setShow] = useState(false);
  const [settled, setSettled] = useState(true);
  const [filter, setFilter] = useState({
    platform: "",
    gameType: "BetFair",
    fromPeriod: previousDate,
    toPeriod: currentDate,
  });

  return (
    <AccountLayout title={t("BettingRecords")}>
      <app-tab-button
        _ngcontent-serverapp-c613070388
        className="ng-tns-c613070388-14"
        _nghost-serverapp-c1092228635
      >
        <div
          _ngcontent-serverapp-c1092228635
          className={`tab-btn-section ng-star-inserted`}
        >
          <div
            _ngcontent-serverapp-c1328719065
            className="tab-btn tab-btn-page"
          >
            <div
              _ngcontent-serverapp-c1328719065
              className="line"
              style={{
                width: "calc(50%)",
                transform: !settled
                  ? "translate(100%, 0px)"
                  : "translate(0%, 0px)",
              }}
            />
            <div
              onClick={() => {
                setSettled(true);
                setFilter({
                  platform: "",
                  gameType: "BetFair",
                  date: "Last 7 days",
                });
              }}
              _ngcontent-serverapp-c1328719065
              drctablinkactive="active"
              className={`btn ${settled ? "active" : ""} ng-star-inserted`}
              data-tab-current={settled ? "current" : ""}
            >
              <div _ngcontent-serverapp-c1328719065 className="text">
                {t("Settled")}
              </div>
            </div>
            <div
              onClick={() => {
                setSettled(false);
                setFilter({
                  platform: "",
                  gameType: "BetFair",
                  date: "Last 7 days",
                });
              }}
              _ngcontent-serverapp-c1328719065
              drctablinkactive="active"
              className={`btn ${!settled ? "active" : ""} ng-star-inserted`}
              data-tab-current={!settled ? "current" : ""}
            >
              <div _ngcontent-serverapp-c1328719065 className="text">
                {t("Unsettled")}
              </div>
            </div>
          </div>
        </div>
      </app-tab-button>
      <div

        _ngcontent-serverapp-c247452493
        className="tab-content tab-content-page content-betting-record ng-tns-c247452493-123"
      >
        <div
          _ngcontent-serverapp-c247452493
          className="ng-tns-c247452493-123 ng-trigger ng-trigger-tabPageTriggerAni"
        >
          <router-outlet
            _ngcontent-serverapp-c247452493
            className="ng-tns-c247452493-123"
          />
          <ng-component
            _nghost-serverapp-c3068904919
            className="ng-tns-c3068904919-124 ng-star-inserted"
            style={{}}
          >
            {settled && (
              <app-search-tab
                _ngcontent-serverapp-c3068904919
                className="ng-tns-c3068904919-124 ng-tns-c2684251700-125 ng-star-inserted"
                _nghost-serverapp-c2684251700
              >
                <div
                  _ngcontent-serverapp-c2684251700
                  className="ng-tns-c2684251700-125 ng-trigger ng-trigger-staggerFadeAnimation tab filter-tab ng-star-inserted"
                >
                  <ul
                    _ngcontent-serverapp-c2684251700
                    className="item-ani ng-tns-c2684251700-125"
                  >
                    {" "}
                    {settled && (
                      <li
                        _ngcontent-serverapp-c2684251700
                        className="active ng-tns-c2684251700-125 ng-star-inserted"
                      >
                        {moment(filter?.fromPeriod).format("YYYY-MM-DD")} -{" "}
                        {moment(filter?.toPeriod).format("YYYY-MM-DD")}
                      </li>
                    )}
                    {/* {!isEmpty(filter?.platform) && (
                    <li
                      _ngcontent-serverapp-c2684251700
                      className="active ng-tns-c2684251700-125 ng-star-inserted"
                    >
                      {filter?.platform}
                    </li>
                  )} */}
                    {!isEmpty(filter?.gameType) && (
                      <li
                        _ngcontent-serverapp-c2684251700
                        className="active ng-tns-c2684251700-125 ng-star-inserted"
                      >
                        {filter?.gameType}
                      </li>
                    )}
                  </ul>
                  <div
                    onClick={() => setShow(true)}
                    _ngcontent-serverapp-c2684251700
                    className="btn search-btn ng-tns-c2684251700-125 ng-star-inserted"
                  >
                    <span
                      _ngcontent-serverapp-c2684251700
                      className="item-icon ng-tns-c2684251700-125 ng-star-inserted"
                      style={{
                        "mask-image":
                          'url("/assets/Other/games-filter-icon.svg")',
                      }}
                    />
                  </div>
                </div>

                <BettingHistoryFilter
                  setShow={setShow}
                  show={show}
                  filter={filter}
                  setFilter={setFilter}
                  settled={settled}
                />
              </app-search-tab>
            )}
            <div
              style={!settled ? { marginTop: "10px" } : {}}
              _ngcontent-serverapp-c3068904919
              className="inner-wrap betting-record-list ng-tns-c3068904919-124 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c3068904919
                className="inner-wrap ng-tns-c3068904919-124"
              >
                <div
                  _ngcontent-serverapp-c3068904919
                  className="inner-box ng-tns-c3068904919-124"
                >
               
                  {!settled && <BettingUnSettled />}
                  {settled && (
                    <BettingSettled searchParams={filter} show={show} />
                  )}
                </div>
              </div>
            </div>
          </ng-component>
        </div>
      </div>
    </AccountLayout>
  );
};

export default BettingHistory;
